import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'AboutVisit',
  components: {
    FibBackButton: require('@/components/BackButton').default
  },
  data: function data() {
    return {
      valid: true,
      errorMessage: '',
      selectedDate: moment().subtract(1, 'h').minute(Math.floor(moment().minute() / 15) * 15).second(0).millisecond(0)
    };
  },
  computed: {
    allowableWindow: function allowableWindow() {
      var _this$survey;

      return ((_this$survey = this.survey(this.surveyInProgress)) === null || _this$survey === void 0 ? void 0 : _this$survey.feedbackAllowableWindow) || null;
    },
    datetime: sync('checkIn/visitDetails@datetime'),
    survey: get('surveys/survey'),
    surveyInProgress: get('surveys/surveyInProgress')
  },
  methods: {
    onSelectDate: function onSelectDate(valid) {
      var now = moment();
      valid = this.selectedDate.isBefore(now); // Disallow future dates

      this.errorMessage = this.$t('checkIn.aboutVisit.timeCantBeFuture'); // Disallow dates before the allowable window

      if (this.allowableWindow && valid) {
        valid = this.selectedDate.isAfter(moment().subtract(this.allowableWindow, 'days').startOf('day'));
        this.errorMessage = this.$t('checkIn.aboutVisit.pleaseEnterAValidTimeAndDate');
      }

      this.valid = valid; // Enables or disables the `Get started` button
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var nextPage;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.valid) {
                  _context.next = 3;
                  break;
                }

                // If we somehow get to this point without a valid date, we should prevent that:
                _this.$store.dispatch('errors/display', {
                  error: _this.$t('checkIn.aboutVisit.pleaseEnterAValidTimeAndDate')
                });

                return _context.abrupt("return");

              case 3:
                // update store
                _this.datetime = cloneDeep(_this.selectedDate); // move on to the next page

                _context.next = 6;
                return _this.$store.dispatch('checkIn/nextPage');

              case 6:
                nextPage = _context.sent;

                _this.$router.push(nextPage);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};